 const config = {
   apiBaseUrl: process.env.REACT_APP_APIBASEURL,
   rcApiBaseUrl: process.env.REACT_APP_RINGCENTRAL_API_BASE_URL,
   rc_client_Id: process.env.REACT_APP_RINGCENTRAL_CLIENT_ID,
   rc_authorize_uri: process.env.REACT_APP_RINGCENTRAL_AUTHORIZE_URI
 };

 module.exports = config;

